import { IoVolumeHighOutline } from "react-icons/io5";
import * as S from "./styles";

interface Props {
  cargos: {
    isCorretor: boolean;
    isGerenteVendas: boolean;
    isSuperintendente: boolean;
  };
}

const CampanhasEmpty: React.FC<Props> = ({ cargos }) => {
  return (
    <S.Container>
      <S.Content>
        <S.Icon>
          <IoVolumeHighOutline size={70} />
        </S.Icon>
        <S.SpaceY space={48} />
        <S.Title>Nenhuma campanha criada ainda!</S.Title>
        <S.SpaceY space={32} />
        {cargos.isGerenteVendas && (
          <>
            <S.Description>
              Crie sua primeira campanha para começar a gerenciar seus contatos
              e melhorar suas vendas.
            </S.Description>
            <S.SpaceY space={32} />
            <S.Button to="/criar-campanha">CRIAR NOVA CAMPANHA</S.Button>
          </>
        )}
      </S.Content>
    </S.Container>
  );
};

export default CampanhasEmpty;
